import { TranslateService } from '@ngx-translate/core';

/** Ancienneté de la dernière trame capteur, formatée côté client (i18n) à partir du timestamp
 *  brut — le backend renvoie aussi `derniereDonnee` déjà formaté, mais en français figé. */
export function formatLastFrame(iso: string | null, translate: TranslateService): string {
  if (!iso) return translate.instant('common.time.never');
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return translate.instant('common.time.secondsAgo', { count: seconds });
  if (seconds < 3600) return translate.instant('common.time.minutesAgo', { count: Math.floor(seconds / 60) });
  return translate.instant('common.time.hoursAgo', { count: Math.floor(seconds / 3600) });
}

export function lastFrameClass(iso: string | null): 'donnee-ok' | 'donnee-warn' | 'donnee-alerte' {
  if (!iso) return 'donnee-alerte';
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return 'donnee-ok';
  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    if (minutes < 10) return 'donnee-ok';
    if (minutes <= 20) return 'donnee-warn';
    return 'donnee-alerte';
  }
  return 'donnee-alerte';
}
